import * as React from "react";
const SvgCandidatePredictionIcon = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", height: "1em", width: "1em", ...props }, /* @__PURE__ */ React.createElement("rect", { fill: "currentColor", height: 24, width: 24 }));
export default SvgCandidatePredictionIcon;
